/*
 * Purpose: Mock-mode sign-in CTA when browsing protected routes anonymously
 * Last modified: 2026-06-28 | Agent
 * Completeness: 92
 */
import { AUTH_CONFIG } from '@/lib/auth-config';
import { useAuthStore } from '@/stores/authStore';
import { ContextualError } from '@/components/errors/ContextualError';

export function AuthMockBanner() {
  const authed = useAuthStore((s) => s.authed);
  if (!AUTH_CONFIG.mock || authed) return null;

  return (
    <div className="shrink-0 px-4 py-2 border-b border-border/60 bg-muted/30">
      <ContextualError
        message={
          window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
            ? 'Local demo mode — sign in stores a session in this browser tab only (not GitHub OAuth).'
            : 'Sign in to isolate flows and secrets per workspace.'
        }
        action={{
          label: 'Sign in',
          href: `${AUTH_CONFIG.signInPath}?next=${encodeURIComponent(window.location.pathname)}`,
        }}
        className="max-w-4xl mx-auto"
      />
    </div>
  );
}

export default AuthMockBanner;
